'use client';
import { Box, List, ListItem, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CustomImage from '@components/CustomImage';
import CommonContainer from '@components/CommonContainer';
import {
  fadeUpAosProps,
  getAosDelay,
  mergeAos,
  zoomInAosProps,
} from '@utils/aosProps';
import AlGhadeerParagraph from '../AlGhadeerParagraph';
import AlGhadeerTitle from '../AlGhadeerTitle';
import {
  DesktopBreakpoint,
  MobileBreakpoint,
  TabletBreakpoint,
} from '@components/Breakpoints';
import cn from './style.module.scss';

export default function AlGhadeerAmenities(props: MarketingPageComponentProps) {
  const amenitiesSection = props?.locale?.section?.find(
    (section: any) => section.type === 'amenities' && section.enabled
  );
  if (!amenitiesSection) return null;

  return (
    <Stack
      component="section"
      className={cn.alGhadeerAmenitiesWrapper}
      id="alGhadeerAmenities"
    >
      <Box className={cn.alGhadeerAmenitiesInner}>
        <CommonContainer
          paddingInline={{ xs: '1.25rem' }}
          maxWidth={{ sm: '100%', md: '1180px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.alGhadeerAmenitiesBlock}>
            <Box className={cn.alGhadeerAmenitiesHeader}>
              <Box
                className={cn.alGhadeerAmenitiesTitle}
                {...mergeAos(fadeUpAosProps, getAosDelay(200))}
              >
                <AlGhadeerTitle
                  titleData={amenitiesSection?.alghadeerAmenitiesHeading}
                />
              </Box>
              <Box
                className={cn.alGhadeerAmenitiesData}
                {...mergeAos(fadeUpAosProps, getAosDelay(200))}
              >
                <AlGhadeerParagraph
                  paragraphData={amenitiesSection?.alghadeerAmenitiesContent}
                />
              </Box>
            </Box>

            <Box className={cn.alGhadeerAmenitiesBody}>
              <List className={cn.alGhadeerAmenitiesList}>
                {amenitiesSection?.alghadeerAmenitiesData?.map(
                  (amenity: any, index: number) => (
                    <ListItem
                      key={index}
                      className={cn.alGhadeerAmenitiesItem}
                      {...mergeAos(
                        zoomInAosProps,
                        getAosDelay(200 + index * 30)
                      )}
                    >
                      <Box className={cn.alGhadeerAmenitiesElement}>
                        <Box className={cn.alGhadeerAmenitiesIcon}>
                          <CustomImage
                            src={amenity.icon}
                            alt={amenity.description}
                            width={64}
                            height={64}
                          />
                        </Box>
                        <Box className={cn.alGhadeerAmenitiesDetails}>
                          <MobileBreakpoint>
                            <ParallaxText
                              variant="p"
                              animationType="zoomIn"
                              animationDuration={500}
                            >
                              {ReactHtmlParser(amenity.titleMobile)}
                            </ParallaxText>
                          </MobileBreakpoint>

                          <TabletBreakpoint>
                            <ParallaxText
                              variant="p"
                              animationType="zoomIn"
                              animationDuration={500}
                            >
                              {ReactHtmlParser(amenity.titleDesktop)}
                            </ParallaxText>
                          </TabletBreakpoint>
                          <DesktopBreakpoint>
                            <ParallaxText
                              variant="p"
                              animationType="zoomIn"
                              animationDuration={500}
                            >
                              {ReactHtmlParser(amenity.titleDesktop)}
                            </ParallaxText>
                          </DesktopBreakpoint>
                        </Box>
                      </Box>
                    </ListItem>
                  )
                )}
              </List>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
